import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { CoachtrainingComponent } from './coachtraining.component';
import { CoachtrainingHomeComponent } from './components/home/coachtraining-home.component';
import { CoachtrainingDepartmentComponent } from './components/department/coachtraining-department.component';
import { CoachtrainingAffiliationComponent } from './components/affiliation/coachtraining-affiliation.component';
import { CoachtrainingCourseComponent } from './components/course/coachtraining-course.component';
import { CoachtrainingSngpComponent } from './components/sngp/coachtraining-sngp.component';
import { CoachtrainingTeacherComponent } from './components/teacher/coachtraining-teacher.component';
import { CoachtrainingCertificationComponent } from './components/certification/coachtraining-certification.component';
import { CoachtrainingAttachedComponent } from './components/attached/coachtraining-attached.component';
import { CoachTrainingEventsComponent } from './components/events/events.component';

/* Routes */
import { CoachtrainingRoutingModule } from './coachtraining-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        CoachtrainingComponent,
        CoachtrainingHomeComponent,
        CoachtrainingDepartmentComponent,
        CoachtrainingAffiliationComponent,
        CoachtrainingCourseComponent,
        CoachtrainingCourseComponent,
        CoachtrainingSngpComponent,
        CoachtrainingTeacherComponent,
        CoachtrainingCertificationComponent,
        CoachtrainingAttachedComponent,
        CoachTrainingEventsComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        CoachtrainingRoutingModule,
        // NgbModule,
        ThemeModule,
        Interceptor,
    ],
})
export class CoachtrainingModule {}
